import { render, staticRenderFns } from "./StepsCard.vue?vue&type=template&id=50a6cd77"
import script from "./StepsCard.vue?vue&type=script&lang=js"
export * from "./StepsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports